module.exports = __webpack_public_path__ + "static/media/ws.69b52e9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ws.svg
// module id = 289
// module chunks = 0